(function () {
	'use strict';

	angular.module('qbePortal').controller('QBCtpValidationController', QBCtpValidationController);

	QBCtpValidationController.$inject = ['$scope', 'validationService', 'Util'];

	function QBCtpValidationController($scope, validationService, util) {
		var vm = this;
			vm.errorField = [];

		var errorsByField = [];

		/*
		* Reset call to validation service		
		*/
		$scope.$on('confirm-form-data', resetFieldErrors);
		function resetFieldErrors() {
			validationService.clearAllErrors();
			errorsByField = [];
			vm.validationSelector = false;
		}

		/*
		* Call validation service to validate fields
		* Param - attribute name of element
		* Output - error object to display in element
		*/
		vm.fetchErrorsByField = function () {
			vm.errorField = [];
			var errors = validationService.validateField(vm.messageKey);

			if (!errors) {
				return [];
				vm.validationSelector = false;
			}		

			for (var input in errors) {
				var error = errors[input];
				var element = error.element;
				var fieldLabel = error.label;
				var fieldErrors = error.errors;
				var ngModel = error.input;
				for (var errorType in fieldErrors) {
					var msg = fieldErrors[errorType];

					if (error.wildcard) {
						var wildcardValue = error.element.scope().$eval(error.wildcard);
						fieldLabel = util.stringFormat(fieldLabel, wildcardValue);
					}

					vm.errorField.push({
						name: element.attr('name'),
						label: fieldLabel,
						id: element.attr('id'),
						errorType: errorType,
						viewValue: element.$viewValue,
						validationMessage: msg,
						section: ngModel.$$parentForm
					});

				}
			}

			if (vm.errorField.length > 0) {
				angular.element('div').find('[data-name='+vm.messageKey+']').removeClass('ng-hide');
			}

			vm.validationSelector = true;
			return vm.errorField;
		}

		/*
		* Broadcast call if field has errors
		*/
		$scope.$on('broadcast-field-errors', function (event) {	
			//validationService.clearAllErrors();		
			errorsByField = vm.fetchErrorsByField();			
		});

		vm.getErrorsByField = function () {
			return errorsByField;						
		}
		
	}

	angular.module('qbePortal').component('qbCtpValidation', {
		templateUrl: '/ngviews/components/qbCtpValidation.html',
		controller: QBCtpValidationController,
		controllerAs: 'vm',
		bindings: {
			validationSelector: '<',
			messageKey: '<',
		}
	});
})();
